// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"cae28d90","222":"17388b57","427":"03a36e85"}[chunkId] + ".chunk.js";
};